/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для слайдера товаров с Суперценой в подкатегориях 2-го уровня.
   */
  app.LocoItemsView = app.View.extend({
    el: '.loco-items',
    template: '#loco-items-template',
    popupTemplate: '#loco-item-popup-template',
    events: {
      'mouseover .loco-item': 'showItemPopup',
      'mouseleave .loco-item-popup': 'removeItemPopup',
      'click .js-button-close': 'closeLocoItems',
    },
    alignTopPopupPosition: 8,
    alignLeftPopupPosition: 12,
    slideBy: 6,
    additionalOptions: [
      'categoryId', 'categoryName', 'currencies', 'currency', 'mainWindow'
    ],

    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.popupTemplate = app.helpers.TemplateHelper.getTemplate(this.popupTemplate);
      this.collection = new app.Items();
      this.listenTo(this.currencies, 'change:current', this.fetchNewPrices);
      this.listenTo(this.collection, 'sync', this.beforeRender);
      this.fetchParams = {
        'main_category_id': this.categoryId,
        'per-page': 20,
        'currency': this.currency ? this.currency.name : 'RUB',
        expand: 'cart_item',
      };
      this.collection.fetch({
        data: this.fetchParams,
      });
    },

    beforeRender: function () {
      if (this.collection.length < 6) {
        return;
      }
      this.childViews.okoWatcher = new app.OkoWatcher(app.OKO_WATCHER_GET_DATA(
        this.el,
        app.OKO_WATCHER_OBJECT_LOCO,
        app.OKO_ALGO.sima_recommend,
        new app.Model(),
        this.mainWindow
      ));
      this.render();
    },
    /**
     * @inheritDoc
     */
    render: function () {
      var that = this,
        collection = this.collection.toJSON();

      this.$el.html(this.template({recommendedItems: collection}));
      this.addOwlCarousel('.loco-items-list');
      setTimeout(function () {
        that.$el.animate({'maxHeight': '178px', 'opacity': '1'}, 'slow');
      }, 500);
    },

    /**
     * Достаем новые цены после смены валюты
     * @param currency
     */
    fetchNewPrices: function (currency) {
      this.fetchParams.currency = currency.get('name');
      this.collection.fetch({
        data: this.fetchParams,
      });
    },

    /**
     * Добавление карусели
     * @param selector класс элемента, к котором находятся дочерние элементы
     */
    addOwlCarousel: function (selector) {
      var $el = this.$el.find(selector);
      var owlConfig = {
        dots: false,
        nav: true,
        responsive: {
          0: this.setOwlParams(6),
          1024: this.setOwlParams(7),
          1200: this.setOwlParams(9),
          1480: this.setOwlParams(11)
        },
        mouseDrag: false,
        margin: 32
      };
      return $el.owlCarousel(owlConfig);
    },

    /**
     * Возвращает объект с параметрами для responsive в owl-карусели
     * @param {number} count Количество item-ов
     * @returns {{items: number, loop: boolean, slideBy: number}} Объект параметрами
     */
    setOwlParams: function (count) {
      var hideItemsCount = this.collection.length - count;
      return {
        items: count,
        loop: this.collection.length > count,
        slideBy: hideItemsCount < this.slideBy && hideItemsCount > 0 ? hideItemsCount : this.slideBy
      };
    },

    /**
     * Показ попапа с товаром
     * @param e
     */
    showItemPopup: function (e) {
      var $element = this.$(e.currentTarget),
        sid = $element.data('sid'),
        locoItem = this.collection.where({sid: sid}),
        topPos,
        leftPos;

      if (this.$('.loco-item-popup').length) {
        this.$('.loco-item-popup').remove();
      }

      if ($element.parent().position()) {
        topPos = $element.parent().position().top;
        leftPos = $element.parent().prevAll('.active').length * $element.parent().outerWidth(true);
      }
      this.$('.loco-items-list').append(this.popupTemplate({locoItem: locoItem[0].toJSON()}));
      this.$('.loco-item-popup').css({
        top: topPos - this.alignTopPopupPosition,
        left: leftPos + this.alignLeftPopupPosition,
      });
      this.initCartButton(locoItem[0]);
    },

    /**
     * Скрытие попапа с товаром
     * @param e
     */
    removeItemPopup: function (e) {
      this.$(e.currentTarget).remove();
    },

    /**
     * Скрытие слайдера с товарами.
     */
    closeLocoItems: function () {
      var that = this;
      this.$el.animate({'maxHeight': '0', 'opacity': '0'}, 'slow', function () {
        that.$el.addClass('not_display');
      });
    },

    /**
     * Инициализация кнопки корзины
     * @param locoItem модель товара в попапе
     */
    initCartButton: function (locoItem) {
      var cartModel = locoItem.get('cart_item') ? locoItem.get('cart_item'): null;
      if (typeof (cartModel) === 'string') {
        cartModel = JSON.parse(decodeURIComponent(cartModel));
      }
      this.childViews.qtyView = new app.RecommendationsItemQtyView({
        el: this.$('.loco-item-popup .btn-block'),
        item: locoItem,
        model: new app.CartItem(cartModel, {item: locoItem}),
        cart: this.cart,
        template: '.btn-xxl-template'
      });
    },
  });
})(jQuery);

}.call(window));